<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link
        class="navbar-item is-size-4"
        :to="{ name: navbarLink() }"
      >
        <img src="@/assets/logo.svg" alt="" class="logo">
      </router-link>

      <div class="navbar-item mobile-only">
        <a
          v-if="user.role === 'participant'"
          href="#"
          class="navbar-link is-arrowless"
          @click.prevent="toggleModal"
        >
          <Information />
        </a>
      </div>

      <a
        role="button"
        :class="{ 'is-active':open }"
        class="navbar-burger burger"
        aria-label="menu"
        data-target="navbarBasicExample"
        :aria-expanded="open"
        @click.prevent="toggleNav"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div
      id="navbarBasicExample"
      :class="{ 'is-active':open }"
      class="navbar-menu"
    >
      <AdminMenu v-if="user.role === 'admin'" />

      <div class="navbar-end">
        <div class="navbar-item desktop-only">
          <a
            v-if="user.role === 'participant'"
            href="#"
            class="navbar-link is-arrowless"
            @click.prevent="toggleModal"
          >
            <Information />
          </a>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link is-arrowless">
            <Account />
          </a>

          <div class="navbar-dropdown is-right">
            <router-link
              v-if="user.role === 'participant'"
              :to="{ name: 'profile' }"
              class="navbar-item"
            >
              <Account />&nbsp;Profile
            </router-link>
            <a
              class="navbar-item"
              @click.prevent="logout"
            >
              <ExitToApp />&nbsp;Logout
            </a>
            <hr
              v-if="role === 'admin'"
              class="navbar-divider"
            >
            <span
              v-if="role === 'admin'"
              class="navbar-item"
            >
              <span><InformationOutline /></span>&nbsp;Env: {{ env }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <HelpModal
      :is-open="isModalOpen"
      @closeModal="toggleModal"
    />
  </nav>
</template>

<script>
import Auth from '@/helpers/auth'
import AdminMenu from '@/components/navigation/AdminMenu'
import HelpModal from '@/components/modals/HelpModal'
import Account from 'vue-material-design-icons/Account.vue'
import Information from 'vue-material-design-icons/Information.vue'
import InformationOutline from 'vue-material-design-icons/InformationOutline.vue'
import ExitToApp from 'vue-material-design-icons/ExitToApp.vue'

export default {
  name: 'Navigation',
  components: {
    AdminMenu,
    HelpModal,
    Account,
    Information,
    InformationOutline,
    ExitToApp
  },
  data () {
    return {
      open: false,
      isModalOpen: false,
      env: process.env.VUE_APP_ENV
    }
  },
  computed: {
    user () {
      return Auth.getUser()
    },
    role () {
      return this.$store.getters['users/role']
    }
  },
  methods: {
    toggleNav () {
      this.open = !this.open
    },
    toggleModal () {
      this.isModalOpen = !this.isModalOpen
    },
    navbarLink () {
      let route = ''
      switch (this.user.role) {
        case 'admin':
          route = 'admin-dashboard'
          break
        case 'participant':
          route = 'participant-dashboard'
          break
      }

      return route
    },
    logout () {
      Auth.logout()
    }
  }
}
</script>

<style lang="scss">
  .navbar{
    position: fixed;
    top: 0;
    width: 100%;
    max-width: 100vw;
    background: $yellow;
    z-index: 2030;

    .logo{
      max-height: 4rem!important;
    }

    .navbar-menu{
      .navbar-end{
        > .navbar-item{
          font-size: 1.3em;
          padding: 15px;
          @include until($desktop) {
            &.has-dropdown{
              padding: 0;
            }
          }
        }
      }
      .navbar-item, .navbar-link{
        color: $primary-color;
        > * {
          color: $primary-color;
        }
        .item{
          border-bottom: 2px solid transparent;
        }
        &:hover{
          color: $primary-color;
          background: transparent;
          > *:not(.navbar-dropdown) {
            background: transparent;
          }
          .item{
            border-bottom: 2px solid $primary-color;
          }
        }
      }
      .navbar-dropdown{
        border-top: 2px solid $primary-color;
        .navbar-item, .navbar-link{
          color: $primary-color;
          > * {
            color: $primary-color;
          }
          &:hover{
            background: $primary-color;
            color: $gray-lightest;
            > * {
              color: $gray-lightest;
            }

            .item{
              &:hover{
                color: $primary-color;
                background: $gray-lightest;
              }
            }
          }
        }
      }
    }

    .desktop-only{
      display: flex;
      @include until($desktop) {
        display: none;
      }
    }

    .mobile-only{
      display: none;
      color: $primary-color;
      font-size: 1.3em;
      padding: 15px;
      > * {
        color: $primary-color;
      }
      &:hover{
        background: transparent;
        color: $gray-lightest;
        > * {
          color: darken($primary-color, 5%);
          background: transparent;
        }
      }

      @include until($desktop) {
        display: block;
        margin-left: auto;
      }
    }

    @include until($desktop) {
      .navbar-brand{
        align-items: center;
      }

      .navbar-burger{
        margin-right: 15px;
        margin-left: 0;
        border: 2px solid $primary-color;
        border-radius: 2px;
        color: $primary-color;
      }

      .navbar-menu{
        position: absolute;
        right: 0;
        background: $primary-color;
        border: 2px solid #10244C;
        box-shadow: 0px 4px 23px -8px rgba(0,0,0,1);
        border-radius: 4px;
        padding: 0;
        z-index: 1000;

        .is-arrowless{
          display: none;
        }

        .navbar-dropdown{
          padding: 0;
          border-top: 1px solid $gray-lightest;
        }

        .navbar-item:not(.has-dropdown), .navbar-link{
          color: $white;
          > * {
            color: $white;
          }
          .item{
            border: none;
          }
          &:hover{
            color: $primary-color;
            background: $gray-lightest;
            > * {
              color: $primary-color;
            }

            .item{
              &:hover{
                color: $primary-color;
                background: $gray-lightest;
              }
            }
          }
        }
      }
    }
  }
</style>
